import type {SenseAction} from 'src/action-creators/types';

import {
  SET_INBOX,
  HIDE_SIDE_BAR,
  SET_SELECTED_THREAD,
  SET_INBOX_TYPE,
} from 'src/action-creators/chat/multi-number-inbox';


export type State = {
  selectedPhoneNumberSetId?: string;
  hideSideBar: boolean;
  selectedThreads: {
    [phoneNumberSetId: number]: string;
  };
  inboxType: string;
};

const initialState = {
  hideSideBar: true,
  selectedThreads: {},
  inboxType: '',
} as const;

export default function reduce(
  state: State | null | undefined = initialState,
  action: SenseAction,
): State {
  switch (action.type) {
    case SET_INBOX: {
      // @ts-expect-error - TS2322 - Type '{ selectedPhoneNumberSetId: string; hideSideBar?: boolean | undefined; selectedThreads?: { [phoneNumberSetId: number]: string; } | undefined; inboxType?: string | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        selectedPhoneNumberSetId: action.payload,
      };
    }
    case HIDE_SIDE_BAR: {
      // @ts-expect-error - TS2322 - Type '{ hideSideBar: boolean; selectedPhoneNumberSetId?: string; selectedThreads?: { [phoneNumberSetId: number]: string; } | undefined; inboxType?: string | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        hideSideBar: action.payload,
      };
    }
    case SET_SELECTED_THREAD: {
      // @ts-expect-error - TS2322 - Type '{ selectedThreads: { [x: number]: string; }; selectedPhoneNumberSetId?: string; hideSideBar?: boolean | undefined; inboxType?: string | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
        selectedThreads: {...state.selectedThreads, ...action.payload},
      };
    }
    case SET_INBOX_TYPE: {
      // @ts-expect-error - TS2322 - Type '{ inboxType: string; selectedPhoneNumberSetId?: string; hideSideBar?: boolean | undefined; selectedThreads?: { [phoneNumberSetId: number]: string; } | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        inboxType: action.payload,
      };
    }
  }

  // @ts-expect-error - TS2322 - Type 'State | null' is not assignable to type 'State'.
  return state;
}
